// import { useFeatures } from "../auth/useFeatures";
import { selectHasFeature } from "../redux/features";
import { useAppSelector } from "../redux/store";
import styles from "./css/FeatureButton.module.css";

interface FeatureButtonProps {
    feature: string;
    onClick?: () => void;
    children: React.ReactNode;
    className?: string;
}
export const FeatureButton = ({
  feature,
  onClick,
  children,
  className,
}: FeatureButtonProps) => {

  const allowed = useAppSelector(selectHasFeature(feature));

  return (
    <button
      className={`${className} ${!allowed ? styles.disabled : ""}`}
      disabled={!allowed}
      onClick={allowed ? onClick : undefined}
    >
      {children}
    </button>
  );
};

// export const ButtonWithFeature = ({ feature, children, ...props }) => {
//   const { hasFeature } = useFeatures();
//   const allowed = hasFeature(feature);

//   return (
//     <button
//       {...props}
//       disabled={!allowed}
//       style={{
//         opacity: allowed ? 1 : 0.4,       // סימן מים
//         cursor: allowed ? "pointer" : "not-allowed", 
//       }}
//     >
//       {children}
//     </button>
//   );
// };
